import require$$0, { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { initReactI18next, I18nextProvider } from "react-i18next";
import i18next from "i18next";
import Fetch from "i18next-fetch-backend";
import styled, { css, keyframes } from "styled-components";
import { composeValidators, requiredValidator, minLengthValidator, maxLengthValidator, requiredValidatorKey, maxLengthValidatorKey, cardExpiryPatternValidator, cardExpiryValidator as cardExpiryValidator$1, minLengthValidatorKey, patternValidatorKey, cardExpiryValidatorKey, getCardCvcLengthRangeByBrand, cardCvcLengthValidator, cardNumberValidator as cardNumberValidator$1, cardNumberValidatorKey } from "@mangopay/checkout-sdk-core";
const i18nConfig = {
  fallbackLng: "en",
  customLanguage: "custom",
  interpolationOptions: {
    escapeValue: false
  }
};
const initI18n = (language) => {
  const instance = i18next.createInstance();
  const preloadedLng = language ?? i18nConfig.fallbackLng;
  let options = {
    fallbackLng: i18nConfig.fallbackLng,
    interpolation: i18nConfig.interpolationOptions,
    initImmediate: true,
    preload: [preloadedLng],
    backend: {
      loadPath: "/locales/{{lng}}.json"
    }
  };
  if (!language || typeof language === "string") {
    options = {
      ...options,
      lng: language
    };
  } else {
    options = {
      ...options,
      resources: {
        [i18nConfig.customLanguage]: {
          translation: language
        }
      },
      lng: i18nConfig.customLanguage
    };
  }
  instance.use(Fetch).use(initReactI18next).init(options).catch(() => {
  });
  return instance;
};
const commonStyles = {
  border: {
    radius: "5px"
  },
  gutters: {
    primary: "14px",
    secondary: "7px"
  },
  inputs: {
    background: "#FFFFFF",
    paddingX: "15px",
    paddingY: "16px"
  },
  fontWeight: {
    semiBold: "500",
    bold: "600"
  },
  payButton: {
    loadingState: {
      border: "#E6E9EC"
    }
  }
};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const attachCustomStylesByClassNames = ({
  className,
  theme
}) => {
  const customStyles = theme == null ? void 0 : theme.rules;
  if (typeof className !== "string" || !customStyles) return null;
  const classNames = className.split(" ");
  const attachStylesToEachClassNames = classNames.map((currentClassName) => customStyles[currentClassName] || customStyles[`.${currentClassName}`]).filter(Boolean);
  const convertAllCustomStylesToCss = attachStylesToEachClassNames.map((currentCss) => css(["", ""], currentCss));
  return convertAllCustomStylesToCss;
};
const TranslationProvider = ({
  language,
  children
}) => {
  const [currentI18n, setCurrentI18n] = useState();
  useEffect(() => {
    const instance = initI18n(language || "en");
    setCurrentI18n(instance);
  }, [language]);
  return currentI18n ? /* @__PURE__ */ jsxRuntimeExports.jsx(I18nextProvider, { i18n: currentI18n, children }) : null;
};
const SpinnerKeyFrame = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const SpinnerAnimation = css(["animation:", " 1s infinite linear;"], SpinnerKeyFrame);
const StyledLoadingState = styled.div.withConfig({
  displayName: "LoadingStatestyled__StyledLoadingState",
  componentId: "sc-sx9dkr-0"
})(["width:", ";height:", ";border-radius:50%;border:6px solid ", ";border-top-color:#000000;", ";", ";"], ({
  size
}) => size, ({
  size
}) => size, commonStyles.payButton.loadingState.border, SpinnerAnimation, (props) => attachCustomStylesByClassNames(props));
const StyledPreloaderWrapper = styled.div.withConfig({
  displayName: "LoadingStatestyled__StyledPreloaderWrapper",
  componentId: "sc-sx9dkr-1"
})(["width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;"]);
const RelalativeWrapper = styled.div.withConfig({
  displayName: "LoadingStatestyled__RelalativeWrapper",
  componentId: "sc-sx9dkr-2"
})(["position:fixed;display:block;width:100%;top:0;bottom:0;background-color:transparent;pointer-events:none;visibility:hidden;opacity:0;transition:visibility 0s ease-in-out 0.3s,opacity ease-in-out 0.3s;", ""], ({
  isVisible
}) => isVisible && css(["pointer-events:all;z-index:999;visibility:visible;opacity:1;background-color:rgba(255,255,255,0.95);"]));
const CenterPosition = styled.div.withConfig({
  displayName: "LoadingStatestyled__CenterPosition",
  componentId: "sc-sx9dkr-3"
})(["position:fixed;left:50%;right:50%;top:50%;display:flex;flex-direction:column;width:200px;transform:translate(-50%,-50%);align-items:center;"]);
const LoadingText = styled.div.withConfig({
  displayName: "LoadingStatestyled__LoadingText",
  componentId: "sc-sx9dkr-4"
})(["font-size:14px;margin-top:40px;"]);
const spinnerAnimation = keyframes(["0%,10%,20%,30%,50%,60%,70%,80%,90%,100%{transform:rotate(calc(var(--rotation) * 1deg)) translate(0,calc(var(--translation) * 1%));}50%{transform:rotate(calc(var(--rotation) * 1deg)) translate(0,calc(var(--translation) * 1.5%));}"]);
const StyledSpinner = styled.div.withConfig({
  displayName: "LoadingStatestyled__StyledSpinner",
  componentId: "sc-sx9dkr-5"
})(["position:relative;width:9px;height:9px;& div{position:absolute;width:50%;height:150%;background:#000000;transform:rotate(calc(var(--rotation) * 1deg)) translate(0,calc(var(--translation) * 1%));animation:", " 1s calc(var(--delay) * 1s) infinite ease;}& div:nth-child(1){--delay:0.1;--rotation:36;--translation:150;}& div:nth-child(2){--delay:0.2;--rotation:72;--translation:150;}& div:nth-child(3){--delay:0.3;--rotation:108;--translation:150;}& div:nth-child(4){--delay:0.4;--rotation:144;--translation:150;}& div:nth-child(5){--delay:0.5;--rotation:180;--translation:150;}& div:nth-child(6){--delay:0.6;--rotation:216;--translation:150;}& div:nth-child(7){--delay:0.7;--rotation:252;--translation:150;}& div:nth-child(8){--delay:0.8;--rotation:288;--translation:150;}& div:nth-child(9){--delay:0.9;--rotation:324;--translation:150;}& div:nth-child(10){--delay:1;--rotation:360;--translation:150;}"], spinnerAnimation);
const LoadingState = ({
  size = "34px"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLoadingState, { className: "LoadingState LoadingState__Spinner", size, children: " " });
const ButtonLoadingOverlayWrapper = styled.div.withConfig({
  displayName: "ButtonLoadingOverlaystyled__ButtonLoadingOverlayWrapper",
  componentId: "sc-nfq6xi-0"
})(["position:relative;"]);
const ButtonLoadingOverlayStyled = styled.div.withConfig({
  displayName: "ButtonLoadingOverlaystyled__ButtonLoadingOverlayStyled",
  componentId: "sc-nfq6xi-1"
})(["position:absolute;width:100%;top:-1px;bottom:-1px;left:0;background-color:rgba(255,255,255,0.8);pointer-events:all;z-index:999;", "{position:absolute;left:50%;margin-top:0;top:8px;}"], StyledLoadingState);
const AmericanIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "34", height: "24", rx: "4", fill: "#1F72CD" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.0954 8.5L2.91429 15.7467H6.72253L7.19464 14.5913H8.27378L8.74589 15.7467H12.9377V14.8649L13.3112 15.7467H15.4795L15.853 14.8462V15.7467H24.5708L25.6309 14.6213L26.6235 15.7467L31.1011 15.7561L27.91 12.1436L31.1011 8.5H26.6929L25.661 9.60463L24.6997 8.5H15.2159L14.4015 10.3704L13.568 8.5H9.76772V9.35186L9.34497 8.5H6.0954ZM6.83228 9.52905H8.68859L10.7986 14.4431V9.52905H12.8321L14.4619 13.0524L15.9639 9.52905H17.9873V14.7291H16.7561L16.746 10.6544L14.9511 14.7291H13.8498L12.0448 10.6544V14.7291H9.51202L9.03185 13.5633H6.43767L5.9585 14.728H4.60146L6.83228 9.52905ZM24.1198 9.52905H19.1136V14.726H24.0423L25.6309 13.0036L27.162 14.726H28.7626L26.4362 12.1426L28.7626 9.52905H27.2315L25.651 11.2316L24.1198 9.52905ZM7.73531 10.4089L6.88063 12.4856H8.58899L7.73531 10.4089ZM20.3499 11.555V10.6057V10.6048H23.4736L24.8366 12.1229L23.4132 13.6493H20.3499V12.613H23.081V11.555H20.3499Z", fill: "white" })
] });
const MaestroIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "34", height: "24", rx: "4", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.25", y: "0.25", width: "33.5", height: "23.5", rx: "3.75", stroke: "black", strokeOpacity: "0.15", strokeWidth: "0.5" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.2576 11.7058C19.2576 15.4092 16.2898 18.4115 12.6288 18.4115C8.96782 18.4115 6 15.4092 6 11.7058C6 8.00227 8.96782 5 12.6288 5C16.2898 5 19.2576 8.00227 19.2576 11.7058Z", fill: "#ED0006" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.8571 11.7058C27.8571 15.4092 24.8893 18.4115 21.2283 18.4115C17.5673 18.4115 14.5995 15.4092 14.5995 11.7058C14.5995 8.00227 17.5673 5 21.2283 5C24.8893 5 27.8571 8.00227 27.8571 11.7058Z", fill: "#0099DF" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9286 6.60205C18.3539 7.83201 19.2576 9.66217 19.2576 11.7059C19.2576 13.7496 18.3539 15.5797 16.9286 16.8097C15.5033 15.5797 14.5996 13.7496 14.5996 11.7059C14.5996 9.66217 15.5033 7.83201 16.9286 6.60205Z", fill: "#6C6BBD" })
] });
const MasterIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "34", height: "24", rx: "4", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.25", y: "0.25", width: "33.5", height: "23.5", rx: "3.75", stroke: "black", strokeOpacity: "0.15", strokeWidth: "0.5" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.179 16.8294C15.9949 17.8275 14.459 18.43 12.7807 18.43C9.03582 18.43 6 15.4303 6 11.73C6 8.02966 9.03582 5.02997 12.7807 5.02997C14.459 5.02997 15.9949 5.63247 17.179 6.63051C18.363 5.63247 19.8989 5.02997 21.5773 5.02997C25.3221 5.02997 28.358 8.02966 28.358 11.73C28.358 15.4303 25.3221 18.43 21.5773 18.43C19.8989 18.43 18.363 17.8275 17.179 16.8294Z", fill: "#ED0006" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1792 16.8294C18.6371 15.6005 19.5616 13.7719 19.5616 11.73C19.5616 9.68801 18.6371 7.85941 17.1792 6.63051C18.3632 5.63247 19.8992 5.02997 21.5775 5.02997C25.3224 5.02997 28.3582 8.02966 28.3582 11.73C28.3582 15.4303 25.3224 18.43 21.5775 18.43C19.8992 18.43 18.3632 17.8275 17.1792 16.8294Z", fill: "#F9A000" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1788 16.8294C18.6367 15.6005 19.5611 13.7719 19.5611 11.73C19.5611 9.68803 18.6367 7.85944 17.1788 6.63054C15.7208 7.85944 14.7964 9.68803 14.7964 11.73C14.7964 13.7719 15.7208 15.6005 17.1788 16.8294Z", fill: "#FF5E00" })
] });
const VisaIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "24", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "34", height: "24", rx: "4", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "0.25", y: "0.25", width: "33.5", height: "23.5", rx: "3.75", stroke: "black", strokeOpacity: "0.15", strokeWidth: "0.5" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.7501 15.8582H8.69031L7.14576 9.79237C7.07245 9.51334 6.91679 9.26666 6.68782 9.1504C6.11639 8.85823 5.48672 8.6257 4.7998 8.50843V8.27489H8.11789C8.57583 8.27489 8.91929 8.6257 8.97653 9.03313L9.77793 13.4086L11.8367 8.27489H13.8392L10.7501 15.8582ZM14.984 15.8582H13.0388L14.6406 8.27489H16.5858L14.984 15.8582ZM19.1025 10.3757C19.1597 9.96728 19.5032 9.73374 19.9039 9.73374C20.5336 9.6751 21.2195 9.79238 21.7919 10.0835L22.1354 8.45081C21.5629 8.21727 20.9333 8.1 20.3619 8.1C18.4738 8.1 17.1 9.15041 17.1 10.6082C17.1 11.7173 18.0731 12.2996 18.7601 12.6504C19.5032 13.0002 19.7894 13.2337 19.7322 13.5835C19.7322 14.1082 19.1597 14.3418 18.5883 14.3418C17.9014 14.3418 17.2145 14.1669 16.5858 13.8747L16.2424 15.5085C16.9293 15.7996 17.6724 15.9169 18.3594 15.9169C20.4763 15.9745 21.7919 14.9251 21.7919 13.35C21.7919 11.3665 19.1025 11.2502 19.1025 10.3757ZM28.5998 15.8582L27.0553 8.27489H25.3962C25.0528 8.27489 24.7093 8.50843 24.5948 8.85823L21.7347 15.8582H23.7372L24.1369 14.7502H26.5973L26.8263 15.8582H28.5998ZM25.6824 10.3171L26.2539 13.1751H24.6521L25.6824 10.3171Z", fill: "#172B85" })
] });
const CarteBancaireIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "34", height: "23", viewBox: "0 0 34 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H30C32.2091 24 34 22.2091 34 20V4C34 1.79086 32.2091 0 30 0Z", fill: "url(#paint0_linear_1335_4166)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12.504 11.5991H17.745C17.6992 10.5637 17.4335 9.49626 16.6318 8.81364C15.6789 7.99817 14.0067 7.6958 12.5178 7.6958C10.9647 7.6958 9.24669 8.03024 8.2892 8.90527C7.46456 9.66119 7.28589 10.8752 7.28589 11.9656C7.28589 13.1063 7.63407 14.4349 8.53201 15.2046C9.48492 16.0201 11.0288 16.2354 12.5223 16.2354C13.97 16.2354 15.5368 15.9926 16.4852 15.2183C17.4289 14.4441 17.7588 13.143 17.7588 11.9702V11.9656H12.504V11.5991Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.0933 11.9563V16.0383H25.3821V16.0337C26.4496 15.9787 27.2971 15.1037 27.2971 14.0225C27.2971 12.9413 26.4496 12.0067 25.3821 11.9563H18.0933Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.1643 9.72987C27.1643 8.68991 26.3396 7.86528 25.2997 7.86528C25.2264 7.86528 25.1393 7.85153 25.0706 7.86069H18.0933V11.6036H25.4417C26.4084 11.5166 27.1643 10.7149 27.1643 9.72987Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1335_4166", x1: "17.0017", y1: "0.0024133", x2: "17.0017", y2: "24.0043", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#1B1F46" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.3515", stopColor: "#1B1F46" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.4737", stopColor: "#2E467E" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5515", stopColor: "#3665A9" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5925", stopColor: "#3665A8" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.6315", stopColor: "#3565A2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.6697", stopColor: "#336699" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.7074", stopColor: "#30668C" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.7448", stopColor: "#2D667A" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.7819", stopColor: "#296663" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.8181", stopColor: "#256449" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.8485", stopColor: "#216230" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#216230" })
  ] }) })
] });
const CardIcon$1 = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "19", height: "20", viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.375 4.45833C1.93777 4.45833 1.58333 4.81277 1.58333 5.25V14.75C1.58333 15.1872 1.93777 15.5417 2.375 15.5417H16.625C17.0622 15.5417 17.4167 15.1872 17.4167 14.75V5.25C17.4167 4.81277 17.0622 4.45833 16.625 4.45833H2.375ZM0 5.25C0 3.93832 1.06332 2.875 2.375 2.875H16.625C17.9367 2.875 19 3.93832 19 5.25V14.75C19 16.0617 17.9367 17.125 16.625 17.125H2.375C1.06332 17.125 0 16.0617 0 14.75V5.25Z", fill: "#737283" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.41667C0 7.97944 0.354441 7.625 0.791667 7.625H18.2083C18.6456 7.625 19 7.97944 19 8.41667C19 8.85389 18.6456 9.20833 18.2083 9.20833H0.791667C0.354441 9.20833 0 8.85389 0 8.41667Z", fill: "#737283" })
] });
const useValidator = (validator, validationOrder) => {
  const [validationResult, setValidationResult] = useState(void 0);
  const [validationErrorType, setValidationErrorType] = useState(void 0);
  const validate = (value) => {
    const result = validator(value);
    setValidationResult(result);
    const resultType = validationOrder.find((errorType) => (result == null ? void 0 : result[errorType]) === false);
    setValidationErrorType(resultType);
    return {
      validationErrorType: resultType,
      validationResult: result,
      isValid: !resultType
    };
  };
  const reset = () => setValidationResult(void 0);
  return {
    validate,
    reset,
    isValid: !validationErrorType,
    validationErrorType,
    validationResult
  };
};
const ErrorMessage = styled.div.attrs({
  className: "ErrorMessage"
}).withConfig({
  displayName: "ErrorMessagestyled__ErrorMessage",
  componentId: "sc-1sn8a8l-0"
})(["color:", ";font-size:", ";margin-top:", ";display:block;", ";"], (props) => props.theme.colors.error, (props) => props.theme.fontSize.secondary, commonStyles.gutters.secondary, (props) => attachCustomStylesByClassNames(props));
const getErrorMessage = ({
  isValid,
  validationErrorType,
  validationMessageByErrorType,
  isCardFormValidationTriggered
}) => {
  const errorMessage = isCardFormValidationTriggered && !isValid && validationErrorType ? validationMessageByErrorType == null ? void 0 : validationMessageByErrorType[validationErrorType] : void 0;
  return errorMessage;
};
const cardBillingNameValidator = composeValidators(requiredValidator, minLengthValidator(1), maxLengthValidator(45));
const cardBillingNameValidationOrder = [requiredValidatorKey, maxLengthValidatorKey];
const cardBillingNameValidationMessageByErrorType = {
  required: "card.billing-name.errors.required",
  minLength: "card.billing-name.errors.min-length",
  maxLength: "card.billing-name.errors.max-length"
};
const cardExpiryValidator = composeValidators(requiredValidator, minLengthValidator(5), maxLengthValidator(5), cardExpiryPatternValidator, cardExpiryValidator$1);
const cardExpiryValidationOrder = [requiredValidatorKey, minLengthValidatorKey, maxLengthValidatorKey, patternValidatorKey, cardExpiryValidatorKey];
const cardExpiryValidationMessageByErrorType = {
  required: "card.expiry.errors.required",
  minLength: "card.expiry.errors.pattern",
  maxLength: "card.expiry.errors.pattern",
  pattern: "card.expiry.errors.pattern",
  cardExpiry: "card.expiry.errors.expired"
};
const cardCvcLengthRange = getCardCvcLengthRangeByBrand("OTHER");
const getCardCvcValidator = (cardBrand) => composeValidators(requiredValidator, cardCvcLengthValidator(cardBrand));
const cardCvcValidationOrder = [requiredValidatorKey, minLengthValidatorKey, maxLengthValidatorKey];
const cardCvcValidationMessageByErrorType = {
  required: "card.cvc.errors.required",
  minLength: "card.cvc.errors.min-length",
  maxLength: "card.cvc.errors.max-length"
};
const cardNumberValidator = composeValidators(requiredValidator, minLengthValidator(14), cardNumberValidator$1);
const cardNumberValidationOrder = [requiredValidatorKey, minLengthValidatorKey, cardNumberValidatorKey];
const cardNumberValidationMessageByErrorType = {
  required: "card.number.errors.required",
  minLength: "card.number.errors.min-length",
  cardNumber: "card.number.errors.invalid-number"
};
const CardIcon = ({
  brand
}) => {
  switch (brand) {
    case "VISA":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(VisaIcon, {});
    case "MASTERCARD":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MasterIcon, {});
    case "AMEX":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AmericanIcon, {});
    case "MAESTRO":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MaestroIcon, {});
    case "CB":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CarteBancaireIcon, {});
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CardIcon$1, {});
  }
};
const SupportedCardBrandContainer = styled.div.withConfig({
  displayName: "SupportedCardBrandsstyled__SupportedCardBrandContainer",
  componentId: "sc-1io5v0z-0"
})(["display:flex;align-items:center;justify-content:flex-end;& > :not(:last-child){margin-right:4px;}", ";"], (props) => attachCustomStylesByClassNames(props));
const POP_UP_FRAMES = keyframes(["from{opacity:0;visibility:hidden;transform:scale(0.8);}to{opacity:1;visibility:visible;transform:scale(1);}"]);
const animationCSS = css(["animation:", " 0.3s ease-out;"], POP_UP_FRAMES);
const SupportedCardBrandIcon = styled.div.withConfig({
  displayName: "SupportedCardBrandsstyled__SupportedCardBrandIcon",
  componentId: "sc-1io5v0z-1"
})(["", ";backface-visibility:hidden;", ";"], animationCSS, (props) => attachCustomStylesByClassNames(props));
const randomInt = (minimum, maximum) => Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
const getArrayDifference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x)).concat(arr2.filter((x) => !arr1.includes(x)));
const MAX_CARD_BRANDS = 5;
const useSupportedCardBrands = ({
  supportedCardBrands
}) => {
  const [cardBrands, setCardBrands] = useState([]);
  const handleRotateCardBrands = useCallback(() => {
    if (!supportedCardBrands) return;
    const indexToUpdate = randomInt(2, 3);
    const diff = getArrayDifference(supportedCardBrands, cardBrands);
    const indexToSelect = randomInt(0, diff.length - 1);
    const cardBrandToAdd = diff[indexToSelect];
    const copyCardBrands = cardBrands.slice();
    copyCardBrands[indexToUpdate] = cardBrandToAdd;
    setCardBrands(copyCardBrands.filter(Boolean));
  }, [supportedCardBrands, cardBrands]);
  useEffect(() => {
    if (!supportedCardBrands) return void 0;
    if (cardBrands.length === 0) {
      setCardBrands(supportedCardBrands == null ? void 0 : supportedCardBrands.slice(0, MAX_CARD_BRANDS));
    }
    if ((supportedCardBrands == null ? void 0 : supportedCardBrands.length) <= MAX_CARD_BRANDS) return void 0;
    const interval = setInterval(() => {
      handleRotateCardBrands();
    }, 5e3);
    return () => clearInterval(interval);
  }, [supportedCardBrands, handleRotateCardBrands]);
  return {
    cardBrands
  };
};
const SupportedCardBrand = ({
  supportedCardBrands
}) => {
  const {
    cardBrands
  } = useSupportedCardBrands({
    supportedCardBrands
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SupportedCardBrandContainer, { className: "SupportedCardBrandContainer", children: cardBrands.map((cardBrand) => /* @__PURE__ */ jsxRuntimeExports.jsx(SupportedCardBrandIcon, { className: "SupportedCardBrandContainer__Icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CardIcon, { brand: cardBrand }) }, cardBrand)) });
};
const Row = styled.div.attrs({
  className: "GridRow"
}).withConfig({
  displayName: "Row",
  componentId: "sc-n3vxy4-0"
})(["display:flex;gap:", ";", ";"], commonStyles.gutters.primary, (props) => attachCustomStylesByClassNames(props));
const Column = styled.div.attrs({
  className: "GridColumn"
}).withConfig({
  displayName: "Column",
  componentId: "sc-eqql5z-0"
})(["width:100%;display:block;position:relative;margin-bottom:", ";", ";"], commonStyles.gutters.primary, (props) => attachCustomStylesByClassNames(props));
const useHandleDropdownClick = ({
  dropdownContentRef,
  isOpen,
  setIsOpen
}) => {
  useLayoutEffect(() => {
    const handleDocumentClick = (event) => {
      if (!dropdownContentRef.current || !isOpen) {
        return;
      }
      const targetElement = event.target;
      const isClickedOutside = !dropdownContentRef.current.contains(targetElement);
      if (isClickedOutside) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isOpen]);
};
export {
  initI18n as A,
  ButtonLoadingOverlayStyled as B,
  CenterPosition as C,
  ButtonLoadingOverlayWrapper as D,
  ErrorMessage as E,
  AmericanIcon as F,
  MasterIcon as G,
  LoadingState as L,
  MaestroIcon as M,
  RelalativeWrapper as R,
  StyledPreloaderWrapper as S,
  TranslationProvider as T,
  VisaIcon as V,
  attachCustomStylesByClassNames as a,
  StyledLoadingState as b,
  LoadingText as c,
  StyledSpinner as d,
  commonStyles as e,
  cardBillingNameValidationMessageByErrorType as f,
  getErrorMessage as g,
  cardBillingNameValidationOrder as h,
  cardBillingNameValidator as i,
  jsxRuntimeExports as j,
  cardExpiryValidationMessageByErrorType as k,
  cardExpiryValidationOrder as l,
  cardExpiryValidator as m,
  getCardCvcValidator as n,
  cardCvcLengthRange as o,
  cardCvcValidationMessageByErrorType as p,
  cardCvcValidationOrder as q,
  SupportedCardBrand as r,
  CardIcon as s,
  cardNumberValidationMessageByErrorType as t,
  useValidator as u,
  cardNumberValidationOrder as v,
  cardNumberValidator as w,
  useHandleDropdownClick as x,
  Column as y,
  Row as z
};
//# sourceMappingURL=useHandleDropdownClick-BQlwGso1.js.map
